const globalConfig = {
  'api_prefix': 'http://www.hdet.com.cn'
}

export default {
  install (Vue, options) {
    Vue.prototype.globalConfig = globalConfig
  }
}



// WEBPACK FOOTER //
// ./src/config.js